/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import PrinterForm from "./PrinterForm";
import { getAll } from "../../../backend/read/GetAll";

const EditPrinter = () => {
    const { state } = useLocation();
    const [activeTags, setActiveTags] = useState(0);
    state.PRINTER_ID && getAll("TAGS").then((tagsData) => {
        let tags = JSON.parse(tagsData.body.data).Items;
        tags && setActiveTags(tags.filter((tag) => {
            let timestamp = new Date(0);
            timestamp.setUTCSeconds(tag.LAST_UPDATED_TIMESTAMP);
            let diff_in_days = Math.round((new Date().getTime() - timestamp.getTime()) / (1000 * 60 * 60 * 24));
            return tag.PRINTER_ID === state.PRINTER_ID && diff_in_days <= 7;
        }).length);
    });
    return (<PrinterForm id={state.PRINTER_ID} printerName={state.PRINTER_ID} stationCode={state.STATION_CODE}
        printerStatus={state.ACTIVE_FLAG.toLowerCase()} activeTagsCount={activeTags} mode={"update"} />);
}

export default EditPrinter;
